import { OrgChartRow } from "./organization-chart";

export class HierarchyService
{
    private nodeHierarchy: Map<string, string[]> = new Map();

    buildHierarchy(data: OrgChartRow[]): void
    {
        this.nodeHierarchy.clear();

        data.forEach(row =>
        {
            if (!row?.Node?.Value)
            {
                return;
            }

            const nodeId = row.Node.Value;
            const managerId = row.ManagerId;

            if (managerId)
            {
                if (!this.nodeHierarchy.has(managerId))
                {
                    this.nodeHierarchy.set(managerId, []);
                }
                this.nodeHierarchy.get(managerId).push(nodeId);
            }
        });
    }
}
